import { module } from 'angular';

import { CommentDirective, default as commentDirectiveName } from './comment.directive';

export default module('contact.commons.toolbox.comment', []).directive(commentDirectiveName, CommentDirective).name;
